import React, { JSX, useContext, useMemo } from "react";
import Head from "next/head";
import Image from "next/image";
import { LogContext } from "context/log";
import { Button } from "@pepdirect/v3/ui/Button";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { META_TITLE, CANONICAL_URL_BASE } from "constants/meta";
import { getCloudflareLoader } from "@pepdirect/v3/helpers/cloudflareImages";
import { endpoints } from "config";
import { PAGE_TYPE_ENUM } from "@pepdirect/v3/types";
import { generatePageId } from "@pepdirect/v3/helpers/analyticsLogger";
import { AppContext } from "context/app";
import { convertFromCentsToDollars } from "@pepdirect/v3/helpers/currency";

import st from "./home.module.scss";

export default function Home(): JSX.Element {
  const { tenant } = useContext(AppContext);
  const headerPromotionText = useMemo(() => {
    return `Enjoy free shipping on all orders over ${convertFromCentsToDollars(
      tenant?.shippingConfig?.freeShippingThreshold || 0,
      "$0,0"
    )}`;
  }, [tenant?.shippingConfig?.freeShippingThreshold]);
  const { useLogPageView } = useContext(LogContext);
  useLogPageView({
    pageType: PAGE_TYPE_ENUM.home,
    pageCategory: undefined,
    pageTitle: META_TITLE,
    id: generatePageId("home"),
  });

  return (
    <div>
      <Head>
        {/* TODO: og tags */}
        <title>{META_TITLE}</title>
        <link rel="canonical" href={CANONICAL_URL_BASE} />
      </Head>
      <div className={st.hero}>
        <div className={st.heroAction}>
          <Heading level="h1" size="xxl">
            Bundles & Beverages
          </Heading>
          <p>
            Your favorites all in one place, delivered right to your door.{" "}
            {headerPromotionText}!
          </p>
          <Button internalLink="/kit/all-bundles">Shop All Bundles</Button>
        </div>
        <figure className={st.heroImageWrapper}>
          <Image
            loader={getCloudflareLoader(endpoints.cdn)}
            src={`/static-images/pantry-shop-icons/pantryshop_hero_spring.png`}
            alt="Products in front of pastel painted flowers"
            fill
            // double largest width for retina screens
            sizes="800px"
            style={{
              objectFit: "contain",
            }}
            priority
          />
        </figure>
      </div>
    </div>
  );
}
